import Vue from 'vue'
import VueMeta from 'vue-meta'
import VueMask from 'v-mask'
import VueLocalStorage from 'vue-localstorage'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueYandexMetrika from 'vue-yandex-metrika'
import moment from 'moment'
import App from './App.vue'
import router from './router'
import store from './storage'
import { applyRouteSeo } from './seo/applyRouteSeo'
import { refreshVueMeta } from './seo/refreshMeta'
import 'uikit'
import 'uikit/dist/css/uikit.css'
import "./assets/styles/uikit-custom.scss"
import "./assets/style.sass"

Vue.config.productionTip = false
Vue.prototype.$moment = moment
Vue.use(VueReCaptcha, { siteKey: `${process.env.VUE_APP_CAPTCHA_SITE_KEY}` })
Vue.use(VueMask)
Vue.use(VueLocalStorage)
Vue.use(VueMeta)

Vue.use(VueYandexMetrika, {
  id: process.env.VUE_APP_METRIC_YANDEX,
  router: router,
  env: process.env.NODE_ENV
})

moment.locale('ru')

router.afterEach(async (to) => {
  await applyRouteSeo(store, to)
  await refreshVueMeta(router)
})

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

const clickOutsideHandlers = new WeakMap();
Vue.directive('clickoutside', {
  inserted(el, binding, vnode) {
    const handler = function clickOutsideHandler(event) {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    clickOutsideHandlers.set(el, handler);
    document.body.addEventListener('click', handler);
  },
  unbind(el) {
    const handler = clickOutsideHandlers.get(el);
    if (handler) {
      document.body.removeEventListener('click', handler);
      clickOutsideHandlers.delete(el);
    }
  },
});